<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th>Nome</th>
          <th>Descrição</th>
          <th>Relatórios</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="profile in profiles" :key="profile.id">
          <td>{{ profile.nome }}</td>
          <td>{{ profile.descricao }}</td>
          <td>
            <p
              v-for="profileCompanyReport in profile.profileCompanyReports"
              :key="profileCompanyReport.id"
            >
              {{ profileCompanyReport.relatorioNome }}
            </p>
          </td>
          <td class="text-center p-2">
            <button
              type="button"
              class="btn btn-outline-warning btn-icon"
              title="Editar"
              @click="$emit('createEditProfile', profile.id)"
            >
              <i class="ph ph-pencil" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'

export default {
  name: 'ListProfiles',

  props: {
    profiles: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListProfiles',
        columnDefs: [
          {
            targets: [3],
            width: 80,
            orderable: false,
          },
        ],
      },
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
